import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { DisplayMode } from '../desktop/MenuDesktopContent';
import menuIcon from '../../../../assets/icons/menu.svg';
import rightArrowIcon from '../../../../assets/icons/right-arrow.svg';
import { MenuItem, ROOT_PRODUCTS_KEY } from '../MenuUtils';
import { MenuLink } from './MenuLink';
import { useTranslation } from 'react-i18next';

interface Props {
  productsDisplayMode?: DisplayMode;
  setProductsDisplayMode?: (displayMode: DisplayMode) => void;
  item: MenuItem;
  closeMenu: () => void;
}

export const MenuSeeAllOption: FunctionComponent<Props> = ({ productsDisplayMode, setProductsDisplayMode, item, closeMenu }) => {
  const { t } = useTranslation('sharedComponents');
  const setDisplayModeCatalog = () => {
    if (setProductsDisplayMode) {
      setProductsDisplayMode(DisplayMode.catalog);
    }
  };

  const isProductCategory = item.key == ROOT_PRODUCTS_KEY;

  return (
    <Container selected={isProductCategory && productsDisplayMode === DisplayMode.catalog}>
      <StyledMenuLink item={item} closeMenu={closeMenu} onClick={isProductCategory ? setDisplayModeCatalog : undefined}>
        <img src={isProductCategory ? menuIcon : rightArrowIcon} alt="" />
        {t(isProductCategory ? 'shared.menu.seeAll' : 'shared.menu.seePage')}
      </StyledMenuLink>
    </Container>
  );
};

const StyledMenuLink = styled(MenuLink)`
  display: flex;
  align-items: center;
`;

const Container = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;

  a {
    text-transform: none;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
    color: ${props => (props.selected ? '#ff0b75' : 'black')};

    &:hover,
    &.selected {
      color: #ff0b75;
    }
  }

  img {
    height: 22px;
    margin-right: 18px;
  }
`;
